export const PRIVACY_POLICY_TITLE_KEY = "legal.privacyPolicy.title";
export const PRIVACY_POLICY_BODY_KEY = "legal.privacyPolicy.body";

export const DEFAULT_PRIVACY_POLICY_TITLE =
  "Политика в отношении обработки персональных данных";

export const DEFAULT_PRIVACY_POLICY_BODY = `1. Общие положения
1.1. Настоящая политика обработки персональных данных определяет порядок обработки и защиты персональных данных, которые могут быть получены от посетителей сайта при использовании сайта, форм обратной связи и иных сервисов.
1.2. Оператор ставит своей целью соблюдение прав и свобод человека и гражданина при обработке персональных данных, в том числе защиту права на неприкосновенность частной жизни, личную и семейную тайну.
1.3. Настоящая политика применяется ко всей информации, которую Оператор может получить о посетителях сайта.

2. Основные понятия, используемые в Политике
2.1. Автоматизированная обработка персональных данных — обработка персональных данных с помощью средств вычислительной техники.
2.2. Блокирование персональных данных — временное прекращение обработки персональных данных, за исключением случаев, когда обработка необходима для уточнения персональных данных.
2.3. Веб-сайт — совокупность графических и информационных материалов, а также программ для ЭВМ и баз данных, обеспечивающих доступность сайта в сети Интернет.
2.4. Обработка персональных данных — любое действие или совокупность действий, совершаемых с персональными данными, включая сбор, запись, систематизацию, хранение, уточнение, использование, передачу, обезличивание, блокирование, удаление и уничтожение.
2.5. Персональные данные — любая информация, относящаяся прямо или косвенно к определенному или определяемому пользователю сайта.

3. Какие данные может обрабатывать Оператор
3.1. Фамилия, имя, отчество пользователя.
3.2. Номер телефона пользователя.
3.3. Адрес электронной почты пользователя.
3.4. Иные сведения, которые пользователь добровольно указывает в формах на сайте.

4. Цели обработки персональных данных
4.1. Обработка входящих обращений и заявок пользователя.
4.2. Обратная связь с пользователем, включая направление уведомлений, ответов на запросы и уточнение деталей записи или обращения.
4.3. Улучшение качества работы сайта и сервисов Оператора.
4.4. Исполнение требований законодательства Российской Федерации.

5. Правовые основания обработки персональных данных
5.1. Оператор обрабатывает персональные данные пользователя только в случае их заполнения и/или отправки пользователем самостоятельно через специальные формы, расположенные на сайте.
5.2. Отправляя свои данные, пользователь выражает согласие с настоящей Политикой.
5.3. Оператор также может обрабатывать обезличенные данные о посетителях сайта с помощью сервисов интернет-статистики при наличии соответствующих настроек браузера пользователя.

6. Порядок обработки и хранения персональных данных
6.1. Оператор обеспечивает сохранность персональных данных и принимает все возможные меры, исключающие доступ к персональным данным неуполномоченных лиц.
6.2. Персональные данные пользователя не передаются третьим лицам, за исключением случаев, связанных с исполнением требований законодательства.
6.3. Срок обработки персональных данных определяется достижением целей, для которых персональные данные были собраны, если иной срок не предусмотрен законодательством.
6.4. Пользователь может отозвать согласие на обработку персональных данных, направив обращение по контактам, указанным на сайте.

7. Заключительные положения
7.1. Пользователь может получить любые разъяснения по вопросам обработки персональных данных, обратившись к Оператору по контактам, указанным на сайте.
7.2. Актуальная версия Политики всегда доступна на данной странице сайта.
7.3. Оператор вправе вносить изменения в настоящую Политику без предварительного уведомления пользователей.`;

export type PrivacyPolicyItem = {
  number: string;
  text: string;
};

export type PrivacyPolicySection = {
  number: string;
  title: string;
  items: PrivacyPolicyItem[];
};

export function parsePrivacyPolicy(text: string): PrivacyPolicySection[] {
  const lines = (text || "")
    .split(/\r?\n/g)
    .map((line) => line.trim())
    .filter(Boolean);

  const sections: PrivacyPolicySection[] = [];
  let currentSection: PrivacyPolicySection | null = null;

  for (const line of lines) {
    const sectionMatch = line.match(/^(\d+)\.\s+(.+)$/);
    const itemMatch = line.match(/^(\d+(?:\.\d+)+)\.?\s+(.+)$/);

    if (sectionMatch && !itemMatch) {
      currentSection = {
        number: sectionMatch[1],
        title: sectionMatch[2],
        items: [],
      };
      sections.push(currentSection);
      continue;
    }

    if (itemMatch) {
      if (!currentSection) {
        currentSection = {
          number: "1",
          title: "Общие положения",
          items: [],
        };
        sections.push(currentSection);
      }

      currentSection.items.push({
        number: itemMatch[1],
        text: itemMatch[2],
      });
      continue;
    }

    if (!currentSection) {
      currentSection = {
        number: "1",
        title: "Общие положения",
        items: [],
      };
      sections.push(currentSection);
    }

    currentSection.items.push({
      number: "",
      text: line,
    });
  }

  return sections;
}